// extracted by mini-css-extract-plugin
export default {"SpinningSVG":"cSUMD3FO59Mpa26E_zm0","rotation":"HnaemauLW7ZI2CtKArAL"};